import { api } from 'utility';
import { getPaymentListUrl, getRDandDetaileInvoiceUrl } from 'URLs';
class InvoiceDetailsServices {
  getInvoice(invoiceId) {
    return api.get(getRDandDetaileInvoiceUrl(invoiceId)).then((res) => res.data);
  }

  paymentLink(uniqueNumber) {
    return api.post(getPaymentListUrl(), { uniqueNumber });
  }
}

export default new InvoiceDetailsServices();
